/**
 * es6 polyfill，用来兼容ie
 * 可根据用到的es6特性按需引入
 */
import './publicPath'
import 'core-js/es6/symbol';
import 'core-js/es6/promise';

import '../ui-lib/lib/tiny/tiny-1.55.0-all';
import 'angular-ui-router/release/angular-ui-router';
import 'base/pre/platformChecker.js';
import 'base/pre/browserChecker.js';
import 'base/pre/langTool.js';
import 'custom/js/language.js';
import 'custom/js/gaTools.js';


// WEBPACK FOOTER //
// ./public/hws/vendor.js